import axios from 'axios';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';

import Select from '~components/Select';

import CompanyList, { ContentsItem } from '../CompanyList';
import { getPublicCompanyList, IPublicCompanyList } from '../helper';
import * as S from '../style';
import { PAGE_COUNT, PUBLIC_COMPANY_LIST } from './constants';

export default function PublicCompanyList() {
  const [publicCompanyList, setPublicCompanyList] = useState<IPublicCompanyList[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>();
  const [hasNextPage, setHasNextPage] = useState<boolean>();
  const [query, setQuery] = useState({
    pagingIndex: 0,
    alioType: '',
  });

  const handleIntersect = useCallback(() => {
    if (!isFetching && hasNextPage) {
      setQuery((prevState) => ({ ...prevState, pagingIndex: prevState.pagingIndex + 1 }));
      setIsFetching(true);
    }
  }, [isFetching, hasNextPage]);

  const handleChangeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
    setQuery({ pagingIndex: 0, alioType: e.target.selectedOptions[0].value });
    setPublicCompanyList([]);
  };

  useEffect(() => {
    getPublicCompanyList({
      pagingIndex: query.pagingIndex * PAGE_COUNT,
      type: query.alioType === '전체' ? '' : query.alioType,
    }).then((response) => {
      setIsFetching(false);

      if (response.data.data.length > 0) {
        setPublicCompanyList((prevState) => [...prevState, ...response.data.data]);
        setHasNextPage(response.data.data.length === PAGE_COUNT);

        return;
      }

      setHasNextPage(false);
    });
  }, [query]);

  return (
    <>
      <S.SelectWrapper>
        <S.Label>각 부처별 선택</S.Label>
        <Select options={PUBLIC_COMPANY_LIST} onChange={handleChangeSelect} />
      </S.SelectWrapper>
      <CompanyList onIntersect={handleIntersect} isFetching={isFetching}>
        {publicCompanyList.map((item, index) => (
          <ContentsItem
            key={`public-company${item.PK_NM_HASH}`}
            href={`/company/${item.PK_NM_HASH}`}
            companyName={item.CMPN_NM}
            avgSalary={item.AVG_SALARY_YY}
            rookeySalary={item.ROOKEY_SALARY_YY}
          />
        ))}
      </CompanyList>
    </>
  );
}
